import React from 'react';
import { CRM_ANTIGUEDAD, CRM_ESTADOS, resolverAntiguedadVisualCrm } from '../../../utils/crmCuentaCorriente';

const ESTILOS_ANTIGUEDAD = {
  [CRM_ANTIGUEDAD.CRITICO]: 'bg-red-600/25 text-red-100 border-red-500/60 ring-1 ring-red-500/30',
  [CRM_ANTIGUEDAD.ALERTA]: 'bg-orange-500/20 text-orange-100 border-orange-500/45',
  [CRM_ANTIGUEDAD.TEMPRANO]: 'bg-amber-500/15 text-amber-100 border-amber-500/35',
  [CRM_ANTIGUEDAD.AL_DIA]: 'bg-emerald-500/15 text-emerald-200 border-emerald-500/30',
  [CRM_ANTIGUEDAD.NEUTRO]: 'bg-white/5 text-e0e3-muted border-e0e3-border/30'
};

const ESTILOS_ESTADO = {
  [CRM_ESTADOS.SIN_MOVIMIENTOS]: 'bg-white/5 text-e0e3-muted border-e0e3-border/30'
};

function resolverLabel(fila, antiguedad) {
  if (fila?.estado === CRM_ESTADOS.SIN_MOVIMIENTOS) return 'Sin movimientos';
  if (fila?.estado === CRM_ESTADOS.AL_DIA) return 'Al día';
  if (antiguedad === CRM_ANTIGUEDAD.CRITICO) return `Vencido +${fila.diasAtraso}d`;
  if (antiguedad === CRM_ANTIGUEDAD.ALERTA) return `Vencido ${fila.diasAtraso}d`;
  if (antiguedad === CRM_ANTIGUEDAD.TEMPRANO) return fila.diasAtraso > 0 ? `Deuda ${fila.diasAtraso}d` : 'Con deuda';
  return 'Con deuda';
}

const CuentaCorrienteEstadoBadge = ({ fila, estado }) => {
  const antiguedad = fila ? resolverAntiguedadVisualCrm(fila) : CRM_ANTIGUEDAD.NEUTRO;
  const clase = fila?.estado === CRM_ESTADOS.SIN_MOVIMIENTOS
    ? ESTILOS_ESTADO[CRM_ESTADOS.SIN_MOVIMIENTOS]
    : (ESTILOS_ANTIGUEDAD[antiguedad] || ESTILOS_ANTIGUEDAD[CRM_ANTIGUEDAD.NEUTRO]);
  const label = fila ? resolverLabel(fila, antiguedad) : (
    { [CRM_ESTADOS.AL_DIA]: 'Al día', [CRM_ESTADOS.CON_DEUDA]: 'Con deuda', [CRM_ESTADOS.VENCIDO]: 'Vencido' }[estado]
    || 'Sin movimientos'
  );

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${clase}`}>
      {label}
    </span>
  );
};

export default CuentaCorrienteEstadoBadge;
